import { Link } from 'react-router-dom';
import { Instagram, Linkedin } from 'lucide-react';

const CfELogo = "https://customer-assets.emergentagent.com/job_b59cf08e-86a7-4284-a0e5-16f32bce918a/artifacts/ahyfrl3q_CFE%20LOGO%20BW.png";

const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Startups', path: '/startups' },
  { name: 'Events', path: '/events' },
  { name: 'Book an Advisor', path: '/advisors' },
  { name: 'Register Your Startup', path: '/register' },
];

const socialLinks = [
  { name: 'Instagram', icon: Instagram, url: 'https://www.instagram.com/cfe_krea?utm_source=ig_web_button_share_sheet' },
  { name: 'LinkedIn', icon: Linkedin, url: 'https://www.linkedin.com/company/cfe-kreauniversity/posts/?feedView=all' },
];

export default function Footer() {
  return (
    <footer className="bg-[#58595B] text-white" data-testid="footer">
      <div className="container-main py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <img 
              src={CfELogo} 
              alt="Centre for Entrepreneurship - Krea University" 
              className="h-[28rem] w-auto object-contain mb-6 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed max-w-md mb-6">
              The Centre for Entrepreneurship at Krea University empowers students, alumni, 
              and faculty to build scalable, sustainable, and impactful startups.
            </p>
            <p className="text-[#4DBDDE] text-sm font-medium">
              Supported by Catalyst — Atal Incubation Center
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6 font-['Bricolage_Grotesque']">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-gray-300 hover:text-white transition-colors text-sm"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="font-semibold text-lg mb-6 font-['Bricolage_Grotesque']">Connect</h4>
            <div className="space-y-4">
              <a 
                href="mailto:cfe@krea.edu.in" 
                className="text-gray-300 hover:text-white transition-colors text-sm block"
              >
                cfe@krea.edu.in
              </a>
              <div className="flex gap-4 pt-2">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#075FA3] flex items-center justify-center transition-all"
                    aria-label={social.name}
                    data-testid={`social-${social.name.toLowerCase()}`}
                  >
                    <social.icon className="w-5 h-5" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Centre for Entrepreneurship, Krea University. All rights reserved.
          </p>
          <Link 
            to="/admin/login" 
            className="text-gray-400 hover:text-white text-sm transition-colors"
            data-testid="admin-login-link"
          >
            Admin Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
